import React, { Component } from 'react';
import { Card } from 'primereact/card';
import { Toast } from 'primereact/toast';
import { Button } from 'primereact/button';
import { DataTable } from 'primereact/datatable';
import { Column } from 'primereact/column';
import { Dialog } from 'primereact/dialog';
import { connect } from 'react-redux';
import Authentication from '../../session';
import withRouter from '../../lib/withRouter';
import Service from '../../../services';
import { baseUrlAdmin } from '../../../store/apiConstants';
import { getBoardsData, getBranchesLatest } from '../../../store/actions';
import { userAssignedBoards } from '../../../store/selectors/userAssignedBoards';
import ClassetDropdown from '../../../classetComponents/classetDropDown';
import ClassetMultiSelect from '../../../classetComponents/classetMultiSelect';
import LoadingComponent from '../../loadingComponent';
import * as XLSX from 'xlsx';

class MarksEntryReport extends Component {
    constructor(props) {
        super(props);
        this.state = {
            isLoading: false,
            reportData: [],

            // Dropdown options
            boardId: null,
            classId: null,
            branchId: null,
            sectionIds: [],
            examinationId: null,
            subjectIds: [],

            // Dropdown data
            classes: [],
            branches: [],
            sections: [],
            examinations: [],
            subjects: [],

            // Report display
            showReport: false,

            // View Dialog
            showViewDialog: false,
            viewDialogData: null,
            selectedSection: null
        };
        this.service = new Service();
    }

    componentDidMount() {
        this.props.getBoardsData(true);
        this.props.getBranchesLatest(true);

        // Load branches if already available
        if (this.props.branchData?.length) {
            this.loadBranches();
        }
    }

    componentDidUpdate(prevProps) {
        // Load branches when branch data is available
        if (!prevProps.branchData?.length && this.props.branchData?.length) {
            this.loadBranches();
        }
    }

    loadBranches = () => {
        // Filter only level 1 branches (actual branches, not sections)
        const branches = this.props.branchData
            ?.filter(branch => branch.level === 1)
            ?.map(branch => ({
                label: branch.name,
                value: branch.key
            })) || [];
        this.setState({ branches });
    }

    onChangeBoard = (boardId) => {
        this.setState({
            boardId,
            classId: null,
            branchId: null,
            sectionIds: [],
            examinationId: null,
            subjectIds: [],
            classes: [],
            sections: [],
            examinations: [],
            subjects: [],
            showReport: false,
            reportData: []
        });

        // Load classes for selected board
        const selectedBoard = this.props.boards?.find(board => board.boardId === boardId);
        if (selectedBoard?.classes?.length) {
            const classes = selectedBoard.classes.map(cls => ({
                label: cls.className,
                value: cls.classId,
                groupId: cls.groupId
            }));
            this.setState({ classes });
        }
    }

    onChangeClass = (classId) => {
        this.setState({
            classId,
            branchId: null,
            sectionIds: [],
            examinationId: null,
            subjectIds: [],
            sections: [],
            examinations: [],
            subjects: [],
            showReport: false,
            reportData: []
        });
    }

    onChangeBranch = (branchId) => {
        this.setState({
            branchId,
            sectionIds: [],
            examinationId: null,
            subjectIds: [],
            sections: [],
            examinations: [],
            subjects: [],
            showReport: false,
            reportData: []
        }, () => {
            this.loadSections();
            this.loadExaminations();
        });
    }

    loadSections = async () => {
        const { boardId, classId, branchId } = this.state;
        if (!boardId || !classId || !branchId) return;

        try {
            this.setState({ isLoading: true });

            // Get sections from boards data structure, not branch hierarchy
            const selectedBoard = this.props.boards?.find(board => board.boardId === boardId);
            const selectedGrade = selectedBoard?.classes?.find(cls => cls.classId === classId);

            if (selectedGrade?.sections) {
                const sections = selectedGrade.sections
                    .filter(section => section.branchId === branchId)
                    .map(section => ({
                        label: section.sectionName,
                        value: section.sectionId
                    }));

                this.setState({ sections });
            } else {
                this.setState({ sections: [] });
            }
        } catch (error) {
            console.error('Error loading sections:', error);
            this.toast.show({
                severity: 'error',
                summary: 'Error',
                detail: 'Failed to load sections',
                life: 3000
            });
        } finally {
            this.setState({ isLoading: false });
        }
    }

    loadExaminations = async () => {
        const { boardId, classId, branchId } = this.state;
        if (!boardId || !classId || !branchId) return;

        try {
            this.setState({ isLoading: true });
            const orgId = localStorage.getItem('orgId');
            const academicYear = localStorage.getItem('userAcademicYear');

            // Build query params - backend will filter examinations
            const queryParams = new URLSearchParams({
                orgId,
                academicYearId: academicYear,
                boardId,
                classId,
                branchId
            });

            const response = await this.service.get(
                `${baseUrlAdmin}/subjective-examinations?${queryParams.toString()}`,
                true
            );

            if (response?.res?.data) {
                const examinations = response.res.data.map(exam => ({
                    label: exam.examName,
                    value: exam.examId,
                    subjects: exam.subjects
                }));
                this.setState({ examinations });
            }
        } catch (error) {
            console.error('Error loading examinations:', error);
            this.toast.show({
                severity: 'error',
                summary: 'Error',
                detail: 'Failed to load examinations',
                life: 3000
            });
        } finally {
            this.setState({ isLoading: false });
        }
    }

    onChangeExamination = (examinationId) => {
        const selectedExam = this.state.examinations.find(e => e.value === examinationId);
        const subjects = selectedExam?.subjects?.map(sub => ({
            label: sub.subjectName,
            value: sub.subjectId
        })) || [];

        this.setState({
            examinationId,
            subjects,
            subjectIds: [],
            showReport: false,
            reportData: []
        });
    }

    validateFilters = () => {
        const { boardId, classId, branchId, sectionIds, examinationId, subjectIds } = this.state;

        if (!boardId) {
            this.toast.show({ severity: 'warn', summary: 'Validation', detail: 'Please select Board', life: 3000 });
            return false;
        }
        if (!classId) {
            this.toast.show({ severity: 'warn', summary: 'Validation', detail: 'Please select Grade', life: 3000 });
            return false;
        }
        if (!branchId) {
            this.toast.show({ severity: 'warn', summary: 'Validation', detail: 'Please select Branch', life: 3000 });
            return false;
        }
        if (!sectionIds?.length) {
            this.toast.show({ severity: 'warn', summary: 'Validation', detail: 'Please select at least one Section', life: 3000 });
            return false;
        }
        if (!examinationId) {
            this.toast.show({ severity: 'warn', summary: 'Validation', detail: 'Please select Examination', life: 3000 });
            return false;
        }
        if (!subjectIds?.length) {
            this.toast.show({ severity: 'warn', summary: 'Validation', detail: 'Please select at least one Subject', life: 3000 });
            return false;
        }
        return true;
    }

    showReport = async () => {
        if (!this.validateFilters()) return;

        try {
            this.setState({ isLoading: true });
            const { examinationId, sectionIds, subjectIds } = this.state;

            const response = await this.service.post(
                `${baseUrlAdmin}/subjective-examinations/results/marks-entry-status`,
                {
                    examId: examinationId,
                    sectionIds,
                    subjectIds
                },
                true
            );

            if (response?.res?.data) {
                this.setState({
                    reportData: response.res.data,
                    showReport: true
                });
            }
        } catch (error) {
            console.error('Error loading report:', error);
            this.toast.show({
                severity: 'error',
                summary: 'Error',
                detail: error?.response?.data?.message || 'Failed to load report data',
                life: 3000
            });
        } finally {
            this.setState({ isLoading: false });
        }
    }

    handleView = (rowData) => {
        this.setState({
            showViewDialog: true,
            viewDialogData: rowData.pendingStudents,
            selectedSection: rowData
        });
    }

    downloadViewDialogData = () => {
        const { viewDialogData, selectedSection, subjectIds, subjects } = this.state;

        if (!viewDialogData?.length) {
            this.toast.show({
                severity: 'warn',
                summary: 'No Data',
                detail: 'No pending marks entry data to download',
                life: 3000
            });
            return;
        }

        // Prepare data for Excel
        const excelData = viewDialogData.map((student, index) => {
            const row = {
                'S.No': index + 1,
                'Enrollment ID': student.enrollmentId,
                'Student Name': student.studentName
            };

            // Add selected subjects columns
            subjectIds.forEach(subjectId => {
                const subject = subjects.find(s => s.value === subjectId);
                const isPending = student.pendingSubjects?.includes(subjectId);
                const isNotAssigned = student.notAssignedSubjects?.includes(subjectId);

                if (isNotAssigned) {
                    row[subject?.label || subjectId] = 'N/A';
                } else if (isPending) {
                    row[subject?.label || subjectId] = 'Pending';
                } else {
                    row[subject?.label || subjectId] = 'Entered';
                }
            });

            return row;
        });

        // Create worksheet
        const ws = XLSX.utils.json_to_sheet(excelData);
        const wb = XLSX.utils.book_new();
        XLSX.utils.book_append_sheet(wb, ws, 'Pending Marks');

        // Download
        XLSX.writeFile(wb, `${selectedSection.sectionName}_Pending_Marks_Entry.xlsx`);

        this.toast.show({
            severity: 'success',
            summary: 'Success',
            detail: 'Data downloaded successfully',
            life: 3000
        });
    }

    renderSubjectStatusColumns = () => {
        const { subjectIds, subjects } = this.state;

        return subjectIds.map(subjectId => {
            const subject = subjects.find(s => s.value === subjectId);
            return (
                <Column
                    key={subjectId}
                    field={`subjectStatus.${subjectId}`}
                    header={subject?.label || subjectId}
                    body={(rowData) => {
                        const status = rowData.subjectStatus?.[subjectId];
                        const entered = status?.entered || 0;
                        const total = status?.total || 0;
                        return `${entered}/${total}`;
                    }}
                    style={{ minWidth: '120px' }}
                />
            );
        });
    }

    renderViewDialogSubjectColumns = () => {
        const { subjectIds, subjects } = this.state;

        return subjectIds.map(subjectId => {
            const subject = subjects.find(s => s.value === subjectId);
            return (
                <Column
                    key={subjectId}
                    field={`pendingSubjects.${subjectId}`}
                    header={subject?.label || subjectId}
                    body={(rowData) => {
                        const isPending = rowData.pendingSubjects?.includes(subjectId);
                        const isNotAssigned = rowData.notAssignedSubjects?.includes(subjectId);

                        if (isNotAssigned) {
                            return <span className="text-gray-500 font-semibold" style={{ fontStyle: 'italic' }}>N/A</span>;
                        } else if (isPending) {
                            return <span className="text-red-500 font-semibold">Pending</span>;
                        } else {
                            return <span className="text-green-500 font-semibold">Entered</span>;
                        }
                    }}
                    style={{ minWidth: '120px' }}
                />
            );
        });
    }

    render() {
        const { reportData, showReport, classes, branches, sections, examinations, subjects } = this.state;

        return (
            <div className="grid">
                <Toast ref={(el) => this.toast = el} />

                <div className="col-12">
                    <Card>
                        {/* Filters Section */}
                        <div className="grid p-fluid">
                            <div className="col-12 md:col-6 lg:col-4">
                                <ClassetDropdown
                                    required={true}
                                    label="Board"
                                    placeholder="Select Board"
                                    options={this.props.boards}
                                    value={this.state.boardId}
                                    onChange={(e) => this.onChangeBoard(e.value)}
                                    optionLabel="boardName"
                                    optionValue="boardId"
                                />
                            </div>

                            <div className="col-12 md:col-6 lg:col-4">
                                <ClassetDropdown
                                    required={true}
                                    label="Grade"
                                    placeholder="Select Grade"
                                    options={classes}
                                    value={this.state.classId}
                                    onChange={(e) => this.onChangeClass(e.value)}
                                    disabled={!this.state.boardId}
                                />
                            </div>

                            <div className="col-12 md:col-6 lg:col-4">
                                <ClassetDropdown
                                    required={true}
                                    label="Branch"
                                    placeholder="Select Branch"
                                    options={branches}
                                    value={this.state.branchId}
                                    onChange={(e) => this.onChangeBranch(e.value)}
                                    disabled={!this.state.classId}
                                />
                            </div>

                            <div className="col-12 md:col-6 lg:col-4">
                                <ClassetMultiSelect
                                    required={true}
                                    label="Section(s)"
                                    placeholder="Select Sections"
                                    options={sections}
                                    value={this.state.sectionIds}
                                    onChange={(e) => this.setState({ sectionIds: e.value, showReport: false, reportData: [] })}
                                    disabled={!this.state.branchId}
                                    optionLabel="label"
                                    optionValue="value"
                                />
                            </div>

                            <div className="col-12 md:col-6 lg:col-4">
                                <ClassetDropdown
                                    required={true}
                                    label="Examination"
                                    placeholder="Select Examination"
                                    options={examinations}
                                    value={this.state.examinationId}
                                    onChange={(e) => this.onChangeExamination(e.value)}
                                    disabled={!this.state.branchId}
                                />
                            </div>

                            <div className="col-12 md:col-6 lg:col-4">
                                <ClassetMultiSelect
                                    required={true}
                                    label="Subject(s)"
                                    placeholder="Select Subjects"
                                    options={subjects}
                                    value={this.state.subjectIds}
                                    onChange={(e) => this.setState({ subjectIds: e.value, showReport: false, reportData: [] })}
                                    disabled={!this.state.examinationId}
                                    optionLabel="label"
                                    optionValue="value"
                                />
                            </div>
                        </div>

                        {/* Action Button */}
                        <div className="flex gap-3 mt-4">
                            <Button
                                label="Show Report"
                                icon="pi pi-eye"
                                onClick={this.showReport}
                                className="p-button-primary"
                            />
                        </div>

                        {/* Report Table */}
                        {showReport && (
                            <div className="mt-4">
                                <DataTable
                                    value={reportData}
                                    paginator
                                    rows={10}
                                    rowsPerPageOptions={[10, 25, 50]}
                                    emptyMessage="No data available"
                                    className="mt-3"
                                >
                                    <Column
                                        header="S.No"
                                        body={(rowData, options) => options.rowIndex + 1}
                                        style={{ minWidth: '70px', maxWidth: '70px' }}
                                    />
                                    <Column
                                        field="gradeName"
                                        header="Grade Name"
                                        style={{ minWidth: '150px' }}
                                    />
                                    <Column
                                        field="sectionName"
                                        header="Section Name"
                                        style={{ minWidth: '150px' }}
                                    />
                                    <Column
                                        field="strength"
                                        header="Strength of Section"
                                        style={{ minWidth: '180px' }}
                                    />

                                    {/* Dynamic Subject Status Columns */}
                                    {this.renderSubjectStatusColumns()}

                                    {/* Actions Column */}
                                    <Column
                                        header="Actions"
                                        body={(rowData) => (
                                            <Button
                                                label="View"
                                                icon="pi pi-eye"
                                                className="p-button-sm p-button-info"
                                                onClick={() => this.handleView(rowData)}
                                            />
                                        )}
                                        style={{ minWidth: '120px' }}
                                    />
                                </DataTable>
                            </div>
                        )}
                    </Card>
                </div>

                {/* View Dialog */}
                <Dialog
                    visible={this.state.showViewDialog}
                    style={{ width: '80vw' }}
                    header={`Pending Marks Entry - ${this.state.selectedSection?.sectionName || ''}`}
                    modal
                    onHide={() => this.setState({ showViewDialog: false, viewDialogData: null, selectedSection: null })}
                    footer={
                        <div>
                            <Button
                                label="Download Excel"
                                icon="pi pi-download"
                                onClick={this.downloadViewDialogData}
                                className="p-button-success"
                            />
                            <Button
                                label="Close"
                                icon="pi pi-times"
                                onClick={() => this.setState({ showViewDialog: false, viewDialogData: null, selectedSection: null })}
                                className="p-button-secondary"
                            />
                        </div>
                    }
                >
                    <DataTable
                        value={this.state.viewDialogData}
                        paginator
                        rows={10}
                        rowsPerPageOptions={[10, 25, 50]}
                        emptyMessage="No pending marks entry"
                        scrollable
                        scrollHeight="400px"
                    >
                        <Column
                            header="S.No"
                            body={(rowData, options) => options.rowIndex + 1}
                            style={{ minWidth: '70px', maxWidth: '70px' }}
                        />
                        <Column
                            field="enrollmentId"
                            header="Enrollment ID"
                            style={{ minWidth: '150px' }}
                        />
                        <Column
                            field="studentName"
                            header="Student Name"
                            style={{ minWidth: '200px' }}
                        />

                        {/* Dynamic Subject Columns */}
                        {this.renderViewDialogSubjectColumns()}
                    </DataTable>
                </Dialog>

                {this.state.isLoading && <LoadingComponent />}
            </div>
        );
    }
}

const mapStateToProps = (state) => ({
    user: state.user,
    boards: userAssignedBoards(state, 'activeBoardsWithoutMeluha'),
    branchData: state.branchDataLatest?.data?.data || []
});

const mapDispatchToProps = {
    getBoardsData,
    getBranchesLatest
};

export default connect(mapStateToProps, mapDispatchToProps)(Authentication(withRouter(MarksEntryReport)));
